import {Avatar, Button, Input, Modal} from 'antd'
import {ChipGroup, Field, Section} from '../../../../components/form/ModernForm'
import {IoPeopleOutline} from 'react-icons/io5'
import {PiBookOpenTextFill} from 'react-icons/pi'
import {
    course_assignStudentToCourseClass_Api,
    course_getCourseClassesAvailForStudent_Api,
    course_getCourseClassStudents_Api,
    course_revokeStudentFromCourseClass_Api,
    course_transferStudentFromCourseClassTo_Api,
    medal_addMedalAward_Api,
} from 'apis'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik, FormikConsumer, useFormikContext} from 'formik'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {AiOutlineAudit} from 'react-icons/ai'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {RiMapPinFill, RiSearchEyeLine, RiUserShared2Line} from 'react-icons/ri'
import {compose, mapProps, pure} from 'recompose'
import {AppEntities} from 'views/AppLocals/enums'
import {NullAsDefault, pagerControls} from 'views/Shared'
import {StudentActionTypes} from '..'
import {course_assignMultiStudentToCourseClass_Api, course_editStudentFromCourseClass_Api} from '../../../../apis'
import DynamicFieldsUtilization from '../../../../components/DynamicFields/DynamicFieldUtilization'
import {createSelectValue, createValue} from '../../../../components/form/utils'
import HeaderGroupItem from '../../../../components/ItemLayout/HeaderGroupItem'
import {FullSideModalLayout} from '../../../../components/Modal/SideModalLayout'
import {createModalTitle} from '../../../../components/renderFunctions/createModalTitle'
import {renderIf, renderIfElse, renderSelf, shallowDiff} from '../../../Shared'
import {
    renderCourseClassStudent,
    STUDENT_TABLE_GRID_CLASS,
    STUDENT_TABLE_GRID_STYLE
} from '../../../Workspace/Course/functions/renderCourseClassStudent'
import EntityList, {NoneStickyMeta} from '../../EntityList'
import {showDeleteConfirmDialog} from '../../factory/createConfirmDialog'
import createContextMenu from '../../factory/createContextMenu'
import {notifyOnError} from '../../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {bindQueryParam, bindQueryParams} from '../../functions/routerHelper'
import {ListHeaderLineAndDes} from '../../Templates/items/ListHeader'
import {CourseClassSelector} from '../components/CourseClassSelector'
import {StudentSelector} from '../components/StudentSelector'
import {CourseClassStudentAttendantsForm} from './CourseClassAttendanceForm'
import {createControlledFormField} from "../../factory/createFormField";
import LookupField from "../../../../components/LookupField";
import {SubClassTags} from "../components/SubClassTags";
import CourseClassContext from "../CourseClassContext";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {MdChurch} from "react-icons/md";
import {StudentInformationFull} from "../Student/components/StudentInformationFull";
import {StudentInformationCompact} from "../Student/components/StudentInformationCompact";
import getTitle from "../../../../helpers/getTitle";
import {GiCardExchange, GiPlainCircle} from "react-icons/gi";
import {GoDash, GoDotFill} from "react-icons/go";
import WorkspaceContext from "../../../Workspace/WorkspaceContext";
import {FaUserGraduate} from "react-icons/fa6";
import Pure from "../../../../components/Pure";
import getAliasName from "../../../../helpers/getAliasName";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import LoadingBlock from "../../../Loading/LoadingBlock";
import withTranslate from "../../../../modules/local/withTranslate";
import {SelectWidget} from "../../custom/ReactSelectComponents";


const StudentInCourseSelection = ({form, name, value, defaultValue = [], handleChange = NullAsDefault, course, course_class, ...props}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const students = value || defaultValue;
    const {organization} = useContext(WorkspaceContext)

    const lookupStudentApiPath = useMemo(() => {
        const params = new URLSearchParams({owner_type: 'organization'})
        if (organization?.id) params.set('owner_id', organization.id)
        if (course?.id) params.set('course_id', course.id)
        if (course_class?.id) params.set('not_course_class_id', course_class.id)
        return `/lookup/student/get-by-types?${params.toString()}`
    }, [organization?.id, course?.id, course_class?.id])

    return (
        <div className="flex flex-col gap-3">
            <div className="flex">
                <LookupField
                    cacheRequired={false}
                    title={t('select student for the class')}
                    description={t('select student for the class description')}
                    createIfNotExists={false}
                    apiPath={lookupStudentApiPath}
                    OptionWrapper={({children, ...props}) =>
                        <div className="p-2 flex items-center gap-2 relative lookup-item" {...props}>
                            {children}
                        </div>
                    }
                    renderOption={(o, i) => {
                        const {avatar, student_idcode, patron_saint_name, fullname, course_class_students = [], registered_subjects = []} = o ?? {}
                        return (
                            <div key={i} className="flex flex-col flex-1 min-w-0 gap-1">
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={35}
                                        src={avatar}
                                        icon={<FaUserGraduate size={15} className="text-color-500"/>}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1 min-w-0">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                            {renderIf(
                                                patron_saint_name,
                                                <span className="mr-1 font-medium text-gray-600 111-111">
                                                    {getAliasName(o, 'patron_saint')}
                                                </span>
                                            )}
                                            {fullname}
                                        </span>
                                        <div className="text-color-400 text-xs tracking-wider">
                                            <span className="whitespace-no-wrap">
                                                {isSm ? '#' : `${t('student code')} : `}
                                            </span>
                                            <span className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                                {student_idcode}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="ml-3 flex flex-col gap-1">
                                    {renderIf(
                                        course_class_students.length > 0,
                                        <div className="space-x-1 text-xs italic tracking-wider">
                                            <GoDotFill size={10} className="text-color-500"/>
                                            <span className="text-color-400 whitespace-no-wrap">
                                                {`${t('learn in the class')} : `}
                                            </span>
                                            {course_class_students.map((e, i) => (
                                                <span className="font-semibold text-color-100 no-underline">
                                                    {getTitle(e?.course_class)}
                                                    {i < course_class_students.length - 1 && ', '}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                    {renderIf(
                                        registered_subjects.length > 0,
                                        <div className="space-x-1 text-xs italic tracking-wider">
                                            <GoDotFill size={10} className="text-color-500"/>
                                            <span className="text-color-400 whitespace-no-wrap italic">
                                                {`${t('subjects registered')} :`}
                                            </span>
                                            {registered_subjects.map((e, i) => (
                                                <span key={i} className="font-semibold text-color-100">
                                                    <GoDash size={10} className="mr-1 text-color-100"/>
                                                    {getTitle(e)}
                                                    {i < registered_subjects.length - 1 && ', '}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    }}
                    placeholder={students.length > 0 ? t('add another student') : t('click to select / create')}
                    handleChange={(e) => {
                        let _students = _.cloneDeep(students);

                        const student = _.find(_students, {id: e.target.id});
                        if (!student) {
                            _students.push({
                                student: e.target,
                                student_name: e.target.value,
                                student_id: e.target.id,
                                id: e.target.id || e.target.value,
                            });
                            handleChange(_students)
                        }
                    }}
                />
            </div>
            {students.map((std, idx) => {
                const {student, student_name} = std ?? {}
                return (
                    <div key={idx} className="p-2 background-50 rounded-lg custom-item-render relative">
                        {renderIfElse(
                            student,
                            <div className="flex items-center gap-2">
                                <Avatar
                                    size={30}
                                    src={student.avatar}
                                    icon={<FaUserGraduate size={16} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex flex-col flex-1">
                                    <span className="font-semibold text-slate-500 leading-snug">
                                        {student?.prefix_title || student?.patron_saint_name || ''}
                                        <span className="ml-1 font-bold text-sm text-color-000">
                                            {getTitle(student)}
                                        </span>
                                    </span>
                                    <span className="font-mono font-medium text-xs text-blue-500 tracking-wider">
                                        #{_.get(student, 'student_idcode')}
                                    </span>
                                </div>
                            </div>,
                            <div className="font-bold text-color-000">
                                {student_name}
                            </div>
                        )}
                        <BiTrash
                            onClick={() => {
                                let _students = _.cloneDeep(students);
                                showDeleteConfirmDialog({
                                    translate: t,
                                    title: 'delete student',
                                    message: 'are you sure you want to delete this student',
                                    onOk: () => {
                                        _.remove(_students, {id: student?.id});
                                        handleChange(_students)
                                    },
                                })
                            }}
                            className="absolute top-8 right-8 contextIcon text-primary-200 hover:text-primary cursor-pointer"
                        />
                    </div>
                )
            })}
        </div>
    )
}

const SectionLabel = ({children}) => (
    <div className="flex items-center gap-2">
        <span className="text-2xs font-bold text-slate-400 uppercase tracking-widest leading-none flex-shrink-0">
            {children}
        </span>
    </div>
)

const formSchema = {
    student: {
        title: 'student',
        children: [
            {
                name: 'student',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(StudentSelector),
            },
        ],
    },
    course_class: {
        // title: 'transfer to class',
        children: [
            {
                name: 'course_class',
                isRequired: true,
                component: mapProps(({name, value, form, onChange}) => {
                    const {course_id, student_id} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        course_id,
                        customConfigs: {
                            apiInfo: course_getCourseClassesAvailForStudent_Api,
                            query: bindQueryParams([{student_id}, {id: course_id}]),
                        },
                        placeholder: 'choose classes',
                    }
                })(CourseClassSelector),
            },
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    rows: 3,
                    className: 'w-full',
                    placeholder: 'notes',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    student_role: {
        title: 'student role',
        children: [
            {
                name: 'role_code',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value}) => ({
                        name,
                        allowClear: true,
                        className: 'w-full',
                        value: value || undefined,
                        onChange: (value) => {
                            onChange(createSelectValue('role_code', value))
                        },
                        placeholder: translate('---Choose One---'),
                        options: ['student', 'student_leader'].map((e) => ({
                            value: e,
                            label: `${translate('role')} ${translate(e)}`,
                        })),
                    })),
                    pure
                )(SelectWidget),
            }
        ],
    },
    sub_class_name: {
        title: 'subclass title',
        children: [
            {
                name: 'sub_class_name',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    const {course} = values ?? {}
                    const owner = _.get(course, 'owner', {})

                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={
                                        values?.sub_class_name
                                    }
                                    apiPath={`/lookup/${getType(owner)}/${getId(owner)}/field/sub_class_name/gets`}
                                    name={name}
                                    placeholder={t('choose or create subclass title')}
                                    handleChange={(e) => {
                                        onChange(
                                            createValue('sub_class_name', e.target.value)
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    information_group_header: {
        children: [
            {
                component: () => <HeaderGroupItem title="manager information"/>,
            },
        ],
    },
    metadata: {
        children: [
            {
                name: 'metadata',
                component: ({name, value, onChange}) => (
                    <DynamicFieldsUtilization
                        name={name}
                        value={value}
                        className="w-full"
                        onChange={(value) => {
                            onChange(createValue(name, value ?? null))
                        }}
                    />
                ),
            },
        ],
    },
    diocese_location: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose parish')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.parish_name}
                                    selectedOption={form?.values?.parish}
                                    placeholder={t('click to select / create')}
                                    apiPath={`/lookup/parish/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        const {fullname, diocese_fullname, location_address} = o ?? {}
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={50}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                />
                                                <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                    <div className="space-x-1 leading-snug">
                                          <span className="font-bold text-sm text-color-000">
                                            {fullname}
                                          </span>
                                                        <span
                                                            className="font-medium text-xs text-blue-500 italic leading-snug">
                                            {`( ${diocese_fullname} )`}
                                          </span>
                                                    </div>
                                                    {renderIf(
                                                        location_address,
                                                        <div className="flex items-center gap-x-1">
                                                            <RiMapPinFill size={11} className="text-color-400"/>
                                                            <span
                                                                className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                {location_address}
                                              </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            parish: e.target,
                                            parish_name: e.target.value,
                                            parish_id: e.target.id,
                                            diocese: e.target.diocese,
                                            diocese_name: e.target?.diocese?.name,
                                            diocese_id: e.target?.diocese?.id
                                        });
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Input disabled={true} value={_.get(form?.values?.diocese, 'fullname')}/>
                    )
                },
            },
        ],
    },
    students_selection: {
        children: [
            {
                name: 'students',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: StudentInCourseSelection,
                    withForm: ({...props}) => ({form: {...props}}),
                    withProps: ({name, value, onChange, ...props}) => {
                        return ({
                            defaultValue: value,
                            handleChange: (_value) => {
                                onChange(createValue(name, _value))
                            },
                            ...props
                        })
                    },
                    withValues: ({resetKey, course, course_class}) => ({
                        resetKey,
                        course, course_class
                    }),
                }),
            },
        ],
    },
}


export const CourseClassStudentAssignmentModal = ({
                                                      course = {},
                                                      courseClass: courseClassProp,
                                                      onSubmit = NullAsDefault,
                                                  }) => {
    const t = useTranslate();
    const {item: courseClassFromContext} = useContext(CourseClassContext)
    const courseClass = courseClassProp || courseClassFromContext
    const {class_subjects = []} = courseClass || {}

    const initialValues = useMemo(
        () => ({
            role_code: "student",
            students: [],
            course,
            course_class: courseClass,
            subject_ids: class_subjects.map(e => {
                return e?.subject?.id;
            })
        }),
        [course, courseClass]
    );


    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {students, sub_class_name, subject_ids} = values ?? {}
                const ids = students.map(item => item.student_id);
                onSubmit({
                    sub_class_name,
                    student_ids: ids,
                    subject_ids
                })
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="add"/>}>
                <div className="my-2 text-color-300 italic">
                    <span className="mr-1 font-medium text-gray-600 underline">{`${t('note')}:`}</span>
                    {t('assign student for class description')}
                </div>
                <div className="flex flex-col space-y-6">
                    <div className="flex flex-col gap-3">
                        <SectionLabel>{t('class information')}</SectionLabel>
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.student_role,
                                    formSchema.sub_class_name,
                                ]}
                            />
                        </Pure>
                    </div>

                    <FormikConsumer>
                        {({values}) => (
                            <div className="flex flex-col gap-3">
                                <SectionLabel>
                                    {_.get(values, 'students.length')
                                        ? `${t('students')} (${values.students.length})`
                                        : t('students')}
                                </SectionLabel>
                                <Pure>
                                    <FieldsFactory formSchema={[formSchema.students_selection]}/>
                                </Pure>
                            </div>
                        )}
                    </FormikConsumer>
                </div>
            </ActionModalWrapper>
        </Formik>
    )
}

// Field component tái dùng NGUYÊN từ formSchema (SelectWidget/LookupField đã viết sẵn, hoạt động
// tốt) - chỉ đổi khung Section/Field bọc ngoài sang Modern Form, không viết lại input logic.
const StudentRoleInput = formSchema.student_role.children[0].component
const SubClassNameInput = formSchema.sub_class_name.children[0].component

// 2 tab hoist Ở MODULE SCOPE (không định nghĩa inline trong render của CourseClassStudentUpdateModal)
// - ActionModalWrapper dùng field.component làm React component TYPE, định nghĩa inline sẽ tạo
// reference mới mỗi lần re-render (mỗi keystroke) -> remount cả tab đang active -> mất focus input,
// LookupField (Tổ/Đội/Nhóm) gọi lại API liên tục - CÙNG bẫy đã ghi chú ở ParishForm.js/
// YellowPageForm.js, code cũ ở đây trước đây dính đúng lỗi này (component: () => (...) inline).
// Đọc values qua useFormikContext() bên trong thay vì nhận qua closure/props.
const CourseClassStudentOverviewTab = ({courseClassStudent}) => (
    <StudentInformationFull {...courseClassStudent}/>
)

const CourseClassStudentManageTab = ({subjectList = []}) => {
    const t = useTranslate()
    const {values, errors, setFieldValue} = useFormikContext()
    const onChange = (e) => setFieldValue(e.target.name, e.target.value)

    // Môn học: danh sách CỐ ĐỊNH, ít lựa chọn (đúng theo lớp/khóa đang có) - ChipGroup (Modern Form)
    // thay Checkbox.Group cũ, trực quan/dễ bấm hơn trên mobile, cùng convention CourseSetForm.js.
    const subjectOptions = subjectList.map((e) => ({
        value: e?.subject ? e?.subject?.id : e?.id,
        label: e?.subject ? e?.subject?.title : e?.title,
    }))

    return (
        <div className="flex flex-col gap-4">
            <Section
                icon={IoPeopleOutline}
                title={t('manage class information')}
                subtitle={t('update student information in the class description')}>
                <Field label={t('student role')}>
                    <StudentRoleInput name="role_code" value={values.role_code} onChange={onChange}/>
                </Field>
                <Field label={t('subclass title')}>
                    <SubClassNameInput name="sub_class_name" value={values.sub_class_name} form={{values}} onChange={onChange}/>
                </Field>
            </Section>
            {subjectOptions.length > 0 && (
                <Section
                    icon={PiBookOpenTextFill}
                    title={t('subjects')}
                    subtitle={t('with subject')}>
                    <Field error={errors.subject_ids}>
                        <ChipGroup
                            multiple
                            options={subjectOptions}
                            value={values.subject_ids}
                            onChange={(next) => setFieldValue('subject_ids', next)}
                        />
                    </Field>
                </Section>
            )}
        </div>
    )
}

export const CourseClassStudentUpdateModal = ({
                                                  course: inputCourse,
                                                  courseClassStudent,
                                                  onSubmit = NullAsDefault
                                              }) => {
    const [current, setCurrent] = useState('overview');

    const {course: courseClassStudentCourse, course_class} = courseClassStudent || {};
    const course = inputCourse || courseClassStudentCourse;

    const initialValues = useMemo(() => ({
            ...courseClassStudent,
            course,
            course_class,
            subject_ids: _.get(courseClassStudent, 'registered_subjects', []).map(e => {
                return e?.id;
            })
        }),
        [courseClassStudent]
    );

    const validate = (values) => {
        let errors = {}

        return errors
    }

    const registeredSubjects = _.get(courseClassStudent, 'registered_subjects', [])

    const subjectList = registeredSubjects.length > 0
        ? registeredSubjects
        : _.get(inputCourse, 'class_subjects', [])

    // useCallback (không hoist hẳn ra module scope được vì cần đóng qua courseClassStudent/subjectList
    // theo đúng instance đang mở) - giữ ổn định reference qua các lần re-render do gõ phím trong tab
    // "additional_info", tránh remount tab đang active (cùng lý do/pattern ParishEditChurchesTab ở
    // ParishForm.js).
    const OverviewTab = useCallback(
        () => <CourseClassStudentOverviewTab courseClassStudent={courseClassStudent}/>,
        [courseClassStudent]
    )
    const ManageTab = useCallback(
        () => <CourseClassStudentManageTab subjectList={subjectList}/>,
        [subjectList]
    )

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={({metadata, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(
                    _.omitBy(
                        {
                            ...(changes ?? {})
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                tab={current}
                action={<FormActionBar submitText="save"/>}
                onTabChange={(key) => {
                    setCurrent(key)
                }}
                tabs={[
                    {key: 'overview', label: 'overview', component: OverviewTab},
                    {key: 'additional_info', label: 'manage class information', component: ManageTab},
                ]}>
            </ActionModalWrapper>
        </Formik>
    )

}

export const CourseClassStudentTransferModal = ({
                                                    course_id,
                                                    owner_id,
                                                    owner_type,
                                                    onSubmit = NullAsDefault,
                                                    course_class_student,
                                                }) => {
    const t = useTranslate()

    const student_id = getId(course_class_student?.student)

    const initialValues = useMemo(
        () => ({
            course_id,
            student_id,
            course_class: undefined,
        }),
        [course_id, student_id, course_class_student]
    )

    const validate = (values) => {
        let errors = {}

        const {course_class} = values ?? {}

        if (!getId(course_class)) {
            errors.course_class = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {course_class} = values ?? {}
                onSubmit({
                    course_class_id: getId(course_class),
                })
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="transfer"/>}>
                <StudentInformationCompact student={course_class_student?.student}/>
                <div className="flex flex-col gap-2 mt-2">
                    <ListHeaderLineAndDes
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <GiCardExchange size={14} className="text-color-500"/>
                                <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                    {t('transfer to class')}
                                </span>
                            </div>
                        )}
                        description="student transfer description"
                    />
                    <div className="ml-2">
                        <FieldsFactory formSchema={[formSchema.course_class]}/>
                    </div>
                </div>
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassStudentList = ({
                                           item,
                                           header = null,
                                           controls = pagerControls,
                                           renderFooter = renderSelf,
                                           container_type = AppEntities.COURSE,
                                           onCourseClassChange = NullAsDefault,
                                       }) => {
    const t = useTranslate()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })
    const {item: courseClass = item} = useContext(CourseClassContext);

    const course = courseClass?.course

    const [refreshToken, setRefreshToken] = useState()

    const {owner} = courseClass ?? {}

    const course_class_id = getId(courseClass)

    const [owner_id, owner_type] = [getId(owner), getType(owner)]

    const {keyword, component: search_widget} = controls?.search ?? {}
    const [sub_class_name, setSubClassName] = useState()
    const [filterSubject, setFilterSubject] = useState(false)

    const apiInfo = course_getCourseClassStudents_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path.replace(':id', course_class_id),
                JSON.stringify(keyword),
                sub_class_name,
                filterSubject?.subject?.id,
                refreshToken,
            ].join(','),
        [keyword, refreshToken, sub_class_name, course_class_id, filterSubject]
    )

    const onError = notifyOnError(t)

    const onCancel = () => {
        setAction({})
    }

    const reload = () => {
        setRefreshToken(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onAssignMulti} = useAsyncAction({
        apiInfo: course_assignMultiStudentToCourseClass_Api,
        onError,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            const updatedCourseClass = _.get(data, 'response.data')
            if (updatedCourseClass) onCourseClassChange(updatedCourseClass)
            reload()
        },
    })

    const {handleAsyncAction: onAssign} = useAsyncAction({
        apiInfo: course_assignStudentToCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: course_editStudentFromCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onRevoke} = useAsyncAction({
        apiInfo: course_revokeStudentFromCourseClass_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onAwardMedal} = useAsyncAction({
        apiInfo: medal_addMedalAward_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onTransfer} = useAsyncAction({
        apiInfo: course_transferStudentFromCourseClassTo_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const handleAction = (action, params) => {
        const id = params?.id
        switch (action) {
            case StudentActionTypes.STUDENT_DETAIL:
            case StudentActionTypes.STUDENT_MOVE:
            case StudentActionTypes.STUDENT_ASSIGN:
            case StudentActionTypes.STUDENT_IN_CLASS_UPDATE:
            case StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY:
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
                setAction({type: action, value: params})
                break
            case StudentActionTypes.STUDENT_REVOKE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'revoke student',
                        message: 'are you sure you want to revoke this student',
                        onOk: () => {
                            onRevoke({}, {id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-color-400"/>,
                        label: 'detail',
                        key: StudentActionTypes.STUDENT_DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'update information',
                        key: StudentActionTypes.STUDENT_IN_CLASS_UPDATE,
                    },
                    {
                        icon: <AiOutlineAudit size={14} className="text-green-600"/>,
                        label: 'attendance tracking',
                        key: StudentActionTypes.STUDENT_ATTENDANCE_TRACKING,
                    },
                    {
                        icon: <RiUserShared2Line size={14} className="text-blue-500"/>,
                        label: 'move student',
                        key: StudentActionTypes.STUDENT_MOVE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: StudentActionTypes.STUDENT_REVOKE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        [course]
    )

    const modal = useMemo(() => {
        let title
        let Content = NullAsDefault
        let params = {title: null}
        let modal_params = {}
        let Wrapper = ({children}) => children({item: {}})

        switch (action?.type) {
            case StudentActionTypes.STUDENT_ATTENDANCE_TRACKING:
                if (container_type === AppEntities.COURSE_CLASS) {
                    title = (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('attendance tracking')}
                        </div>
                    )
                    params = {
                        onCancel,
                        courseClass: item,
                        student: action?.value?.student,
                    }
                    modal_params = {
                        width: 640,
                    }
                    Content = CourseClassStudentAttendantsForm
                    break
                } else {
                    return (
                        <FullSideModalLayout
                            right={true}
                            onCancel={onCancel}
                            title={createModalTitle('attendance tracking')}>
                            <CourseClassStudentAttendantsForm
                                courseClass={item}
                                student={action?.value?.student}
                            />
                        </FullSideModalLayout>
                    )
                }
            case StudentActionTypes.STUDENT_IN_CLASS_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update student information in the class')}
                    </div>
                )
                params = {
                    courseClassStudent: action?.value,
                    course: courseClass,
                    source: 'CourseClassStudentForm',
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {
                            id: action?.value?.id,
                        })
                    },
                }
                modal_params = {
                    width: 768,
                }
                Content = CourseClassStudentUpdateModal
                break
            case StudentActionTypes.STUDENT_ASSIGN:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('assign course class student')}
                    </div>
                )
                params = {
                    course: item?.course,
                    courseClass: item,
                    onCancel,
                    onSubmit: (values) => {
                        const {...rest} = values ?? {}
                        onAssignMulti(
                            {...rest},
                            {
                                course_class_id,
                            }
                        )
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = CourseClassStudentAssignmentModal
                break
            case StudentActionTypes.STUDENT_MOVE:
                const {course, ...course_class_student} = action?.value ?? {}
                const course_id = getId(course)
                const course_class_student_id = getId(course_class_student)
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('move student')}
                    </div>
                )
                params = {
                    course_class_student,
                    course_id,
                    onCancel,
                    onSubmit: (values) => {
                        const {course_class_id} = values ?? {}
                        onTransfer(
                            {},
                            {
                                course_class_id,
                                course_class_student_id,
                            }
                        )
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = CourseClassStudentTransferModal
                break
            case StudentActionTypes.STUDENT_DETAIL:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('student information')}
                    </div>
                )
                params = {
                    item: action?.value
                }
                modal_params = {
                    width: 640,
                }
                Content = () => {
                    return (
                        <div className="flex flex-col gap-6 mb-6">
                            {_.get(action?.value, 'registered_subjects.length') > 0 && (
                                <div className="flex flex-col gap-3">
                                    <div className="flex flex-col">
                                    <span className="font-semibold text-sm text-gray-700 tracking-wide">
                                        {t('registered subjects')}
                                    </span>
                                        <div style={{ height: 3 }} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                                    </div>
                                    {renderIf(
                                        _.get(action?.value, 'registered_subjects.length') > 0,
                                        <div className="ml-2 grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                                            {_.get(action?.value, 'registered_subjects', []).map((e, i) => (
                                                <span key={i} className="flex items-center gap-x-2">
                                            <GiPlainCircle size={7} className="text-blue-200"/>
                                            <span className="font-semibold text-blue-600 text-sm italic leading-snug">
                                                {getTitle(e)}
                                            </span>
                                        </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                            <StudentInformationFull {...action?.value}/>
                        </div>
                    )
                }
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {

                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type, course_class_id])

    const {
        class_subjects = [],
        coordinators = [],
        sub_class_names = [],
        number_of_students,
        description,
        course_class_idcode,
        title,
    } = courseClass ?? {}

    return renderIf(
        courseClass,
        <ActionModalWrapper style={{ fontSize: 14 }} className="flex-1">
            {header}
            <div className="flex flex-col md:flex-row md:items-center gap-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-base text-slate-600 tracking-wide">
                        {t('list of students')}
                    </h2>
                    <div style={{ height: 3 }} className="my-1 w-20 rounded-full bg-gray-400"/>
                </div>
                <Button
                    color="primary" variant="filled"
                    className="font-semibold rounded-lg"
                    onClick={() => {
                        handleAction(StudentActionTypes.STUDENT_ASSIGN)
                    }}>
                    {t('add student')}
                </Button>
            </div>
            <div className="flex flex-col gap-3 flex-1">
                {search_widget}
                <div className="flex flex-col gap-3">
                    {renderIf(
                        class_subjects.length > 0,
                        <div className="flex items-baseline gap-1">
                            <span className="text-color-400 whitespace-no-wrap leading-snug tracking-wider 111-111">
                                {`${t('subjects')} : `}
                            </span>
                            <div className="flex flex-wrap gap-y-1 gap-x-2">
                                {class_subjects.map((e, i) => (
                                    <span
                                        key={i}
                                        style={{padding: '2px 8px', height: 26}}
                                        onClick={() => {
                                            if (filterSubject === e) {
                                                setFilterSubject(null)
                                            } else {
                                                setFilterSubject(e)
                                            }
                                        }}
                                        className={classNames(
                                            'flex items-center text-xs font-medium rounded-lg border cursor-pointer transition-all duration-300',
                                            filterSubject === e
                                                ? 'bg-indigo-600 border-indigo-600 text-white'
                                                : 'border-color-200 text-color-200 hover:border-indigo-400 hover:text-indigo-500'
                                        )}>
                                        {e?.subject?.title}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                    {renderIf(
                        sub_class_names.length > 0 || true ,
                        <div className="flex items-baseline gap-1">
                            <span className="text-color-400 whitespace-no-wrap leading-snug tracking-wider 111-111">
                                {`${t('subclass title')} : `}
                            </span>
                            <SubClassTags
                                items={_.get(item, 'sub_class_names', [])}
                                selected={sub_class_name}
                                setSelected={setSubClassName}
                            />
                        </div>
                    )}
                </div>
                <EntityList
                    cacheId={refreshKey}
                    key={refreshKey}
                    apiInfo={apiInfo}
                    values={{keyword, sub_class_name, subject_id: filterSubject?.subject?.id, sort_by: 'name asc'}}
                    RenderEntity={React.Fragment}
                    PaginationMeta={NoneStickyMeta}
                    query={bindQueryParam({id: course_class_id})}
                    renderItem={renderCourseClassStudent({
                        translate: t,
                        renderContextMenu,
                    })}
                    renderWrap={(child) => (
                        <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                            {/* Header cột - CÙNG grid-template-columns với từng dòng
                                (STUDENT_TABLE_GRID_CLASS, renderCourseClassStudent.js) để không lệch
                                cột nếu sau này đổi độ rộng. Ẩn dưới sm vì mobile đã có nhãn nhỏ dẫn
                                trước mỗi giá trị thay cho header (xem renderCourseClassStudent). */}
                            <div
                                style={STUDENT_TABLE_GRID_STYLE}
                                className={`hidden ${STUDENT_TABLE_GRID_CLASS} px-4 py-2 background-100`}>
                                <span className="text-2xs font-semibold text-color-300 uppercase tracking-wider">
                                    {t('student')}
                                </span>
                                <span className="text-2xs font-semibold text-color-300 uppercase tracking-wider">
                                    {t('student code')}
                                </span>
                                <span className="text-2xs font-semibold text-color-300 uppercase tracking-wider">
                                    {t('class group')}
                                </span>
                            </div>
                            {child}
                        </div>
                    )}
                />
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}


